<template>
  <input
    :class="customClass"
    ref="input"
    @input="updateValue($event.target.value)"
    @focus="selectAll"
    @blur="formatValue"
  >
</template>

<script>
  import moment from 'moment'
  import config from '../../config' // eslint-disable-line no-unused-vars
  export default {
    props: {
      date: {
        type: Object,
        default () {
          return moment(config.now).set({'hour': 8, 'minutes': 0})
        }
      },
      customClass: {
        default: 'd-time-change-input'
      }
    },
    watch: {
      date () {
        // if prop date changes from parent we need formatting
        if (this.active === false) {
          this.$refs.input.value = moment(this.date).format('LT')
        }
      }
    },
    data () {
      return {
        active: false
      }
    },
    methods: {
      updateValue (val) {
        this.$emit('changed', val)
      },
      formatValue () {
        this.$emit('blur')
        this.$refs.input.value = moment(this.date).format('LT')
        this.active = false
      },
      selectAll: function (event) {
        setTimeout(function () {
          event.target.select()
        }, 0)
        this.active = true
      }
    },
    mounted () {
      this.$refs.input.value = moment(this.date).format('LT')
    }
  }
</script>



// WEBPACK FOOTER //
// TimeInput.vue?6126108f